import * as Yup from 'yup'

export const FIRST_NAME = 'first_name'
export const LAST_NAME = 'last_name'
export const EMAIL = 'email'
export const PHONE_NUMBER = 'phone_number'

export const initialRepresentativeValue = {
  [FIRST_NAME]: '',
  [LAST_NAME]: '',
  [EMAIL]: '',
  [PHONE_NUMBER]: ''
}

export const getInitialValues = selectedRepresentative => ({
  [FIRST_NAME]: selectedRepresentative[FIRST_NAME] || '',
  [LAST_NAME]: selectedRepresentative[LAST_NAME] || '',
  [EMAIL]: selectedRepresentative[EMAIL] || '',
  [PHONE_NUMBER]: selectedRepresentative[PHONE_NUMBER] || ''
})

export const representativeValidationSchema = Yup.object({
  [FIRST_NAME]: Yup.string().required('First Name is required'),
  [EMAIL]: Yup.string().required('Email is required')
})
